/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_BathsInputs */

const en_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baths`)
};

const es_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baños`)
};

const fr_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bains`)
};

const de_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bäder`)
};

const ja_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お風呂/シャワー数`)
};

const zh_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`洗浴间`)
};

const ar_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحمامات`)
};

const id_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamar Mandi`)
};

const it_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagni/Docce`)
};

const ru_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ванны/Душ`)
};

const pt_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banheiros/Duchas`)
};

const ko_field_baths = /** @type {(inputs: Field_BathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`욕조`)
};

/**
* | output |
* | --- |
* | "Baths" |
*
* @param {Field_BathsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_baths = /** @type {((inputs?: Field_BathsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_BathsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_baths(inputs)
	if (locale === "es") return es_field_baths(inputs)
	if (locale === "fr") return fr_field_baths(inputs)
	if (locale === "de") return de_field_baths(inputs)
	if (locale === "ja") return ja_field_baths(inputs)
	if (locale === "zh") return zh_field_baths(inputs)
	if (locale === "ar") return ar_field_baths(inputs)
	if (locale === "id") return id_field_baths(inputs)
	if (locale === "it") return it_field_baths(inputs)
	if (locale === "ru") return ru_field_baths(inputs)
	if (locale === "pt") return pt_field_baths(inputs)
	return ko_field_baths(inputs)
});